module.exports = __webpack_public_path__ + "sky.2069b54d09badc9411b8.png";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/images/themes/footer/style02/sky.png
// module id = ../../../../../src/assets/images/themes/footer/style02/sky.png
// module chunks = 2